import { Component, OnInit, ViewChild } from '@angular/core';
import { WebParameterContext } from '../../../../model/common';
import { IonInfiniteScroll } from '@ionic/angular';
import { HttpCustomerService, MessageclientService } from 'src/service';
import { ActivatedRoute, Router } from '@angular/router';
import { CommonService } from 'src/service/common.service';
import { BaseCase } from 'src/app/basecase';
import { BaseModal } from 'src/model';
import { NativeService } from '../../../../service/native.service';
import { GridBaseCase } from '../../grid/grid.base.case';
declare var app;
@Component({
  selector: 'app-gift-receipt-list',
  templateUrl: './gift-receipt-list.component.html',
  styleUrls: ['./gift-receipt-list.component.scss']
})
export class GiftReceiptListComponent extends GridBaseCase {
  searchValue: any; //搜索的变量
  tabstranIndex: number = 3;
  month: any = new Date();
  arrayData: Array<any> = [];
  erraMsg: any = null;
  uploadNum: any = [];
  PageNumber: number = 0;
  RecordCount: Number = 0;//列表总数量
  apiObj = {
    status: false,
    msg: ''
  };//接口状态
  loading: boolean = false;//加载效果
  // approvalType: any = "3";//审核类型
  // approvalTypeList:any = [{'a_Code':"0",'a_Name':'全部'},{'a_Code':"3",'a_Name':'待审批'},{'a_Code':"1",'a_Name':'审批通过'},{'a_Code':"2",'a_Name':'审批失败'},{'a_Code':"4",'a_Name':'无需审批'}];//审批类型数据源
  // approvalSelectText:string = "待审批";
  signType:any = "1";//签收类型
  signTypeList:any = [{'a_Code':"0",'a_Name':'全部'},{'a_Code':"1",'a_Name':'待签收'},{'a_Code':"2",'a_Name':'已签收'}];//签收类型数据源
  signSelectText:string = "待签收";
  beginDate:any = null;//开始日期
  endDate:any = null;//结束日期
  pageName:string = null;
  selectrue:boolean=false; // 按钮点击
  selectrueend:boolean = false; // 结束时间
  @ViewChild(IonInfiniteScroll) infiniteScroll: IonInfiniteScroll;
  constructor(
    private http: HttpCustomerService,
    private activaRouter: ActivatedRoute,
    private router: Router,
    private msg: MessageclientService,
    private com: CommonService,
    public baseService: BaseCase,
    public base: BaseModal,
    public native: NativeService
  ) {
    super();
    this.pageName = this.activaRouter.snapshot.paramMap.get('ConfigName');
    this.month = this.com.getNow;
    // this.beginDate = this.com.getNow;
    // this.endDate = this.com.getNow;
    this.beginDate = "";
    this.endDate = "";
    
  }

  ngOnInit() {
  }
  // 搜索条件
  serarEvent(e, type: string = 'type') {

    const that = this;
    // if (!that.searchValue) {
    //   that.msg.Alert("物流单号不能为空哦！");
    //   return;
    // }
    if(e.keyCode == 13 || type=='search'){
      that.LoadData(1);
    }
  }
  tabstranEvent(num) {
    const that = this;
    that.tabstranIndex = num;
    that.LoadData(1)
  }
  // 日期查询
  EventDateTimeClick1() {
    let that = this;
    console.log(that.beginDate);
    let _obj = {
      value: that.beginDate,
      format: "yyyymmdd"
    };
    that.native.IosselectDateTime(_obj).then(data => {
      that.beginDate = that.formatDate(data.value);
      that.selectrue = true;
      if(new Date(that.endDate.replace(/-/g,"/")).getTime() < new Date(that.beginDate.replace(/-/g,"/")).getTime()){
        that.msg.Alert("开始日期必须小于结束日期！");
        that.beginDate = that.endDate;
      }
      console.log("测试");
    }).catch(eror => {
      console.log(eror);
    });
  }
    // 日期查询
    EventDateTimeClick2() {
      console.log("测试1");
      let that = this;
      console.log(that.endDate);
      let _obj = {
        value: that.endDate,
        format: "yyyymmdd"
      };
      that.native.IosselectDateTime(_obj).then(data => {
        that.endDate = that.formatDate(data.value);
        that.selectrueend = true;
        if(new Date(that.endDate.replace(/-/g,"/")).getTime() < new Date(that.beginDate.replace(/-/g,"/")).getTime()){
          that.msg.Alert("开始日期必须小于结束日期！");
          that.endDate = that.beginDate;
        }
        
        console.log("测试");
      }).catch(eror => {
        console.log(eror);
      });
    }
  formatDate(date) {
    if (date) {
      let _date = new Date(date.replace(/-/g, "/"));
      let _y = _date.getFullYear();
      let _m = _date.getMonth() + 1;
      let _d = _date.getDate();
      return _y + "-" + (_m < 10 ? "0" + _m : _m) + "-" + (_d < 10 ? "0" + _d : _d);
    } else {
      return date;
    }
  }

  close(){
    const that =this;
    that.selectrue = false;
    that.beginDate = "";
    that.LoadData(1);
  }
  // 结束时间
  closeEnd(){
    const that =this;
    that.selectrueend = false;
    that.endDate = "";
    that.LoadData(1);
  }
  /**
   * 审核类型改变
   * @param e 
   */
  // approvalChangeSelect(e){
  //   let that = this;
  //   that.approvalType = e.target.value;
  //   that.approvalTypeList.forEach((item)=>{
  //     if(item["a_Code"] == that.approvalType){
  //       that.approvalSelectText = item["a_Name"];
  //     }
  //   })
     

  // }

  /**
   * 签收类型改变
   */
  signChangeSelect(e){
    let that = this;
    that.signType = e.target.value;
      that.signTypeList.forEach((item)=>{
        if(item["a_Code"] == that.signType){
          that.signSelectText = item["a_Name"];
        }
      })
      // if(that.approvalType == '000000'){
      //   that.approvalSelectText = "全部";
      // }
    // this.LoadData(1);
  }

  ngAfterViewInit() {
    const that = this;
    let searchArr = that.com.GetStorageKey("searchArray") || [];
  
    if(searchArr.length > 0){
      searchArr.forEach(item=>{
        if(item.pageName == that.pageName){
          that.searchValue = item.searchInput || "";
          // that.approvalType = item.selectItem || "3";
          // that.approvalSelectText = item["selectText"] || "待审批";
          // that.signType = item.selectItem1 || "";
          // that.signSelectText = item["selectText1"] || "";
          // that.beginDate = item["beginDate"] || that.com.getNow;
          // that.endDate = item["endDate"] || that.com.getNow;
        }
      })
    }
    that.LoadData(1);
  }
  loadMoreData(event) {
    let that = this;
    if (that.RecordCount == that.arrayData.length) {
      that.infiniteScroll.disabled = true;
    } else {
      that.PageNumber++;
      that.LoadData(that.PageNumber);
    }
  }
  LoadData(PageNumber) {
    let that = this;
    that.PageNumber = PageNumber;
    if (PageNumber == 1) {
      that.loading = false;
      that.apiObj['status'] = false;
      that.apiObj['msg'] = '';
    }
    // let _dy: any = {
    //   StartTime:that.beginDate+" 00:00:00",
    //   EndTime:that.endDate+" 23:59:59"
    // };
    let _dy: any={};
    if(that.beginDate){
      _dy["StartTime"] = that.beginDate+" 00:00:00";
    }
    if(that.endDate){
      _dy["EndTime"]=that.endDate+" 23:59:59";
    }
    if(that.searchValue){//查询物流单号
      _dy["TrackingNumber"] = that.searchValue;
    }
    if(that.signType != "0"){//选择了签收类型
      _dy["SignState"] = parseInt(that.signType);
    }
    // if(that.approvalType != "0"){//选择了审核类型
    //   _dy["ExamineState"] = parseInt(that.approvalType);
    // }
    const _searchObj = {
      pageName:that.pageName,
      searchInput:that.searchValue,
      // selectItem:that.approvalType,
      // selectText:that.approvalSelectText,
      selectItem1:that.signType,
      selectText1:that.signSelectText,
      beginDate:that.beginDate,
      endDate:that.endDate,
    };
    that.com.SaveSearchInfo(_searchObj);
    const PageName = that.activaRouter.snapshot.paramMap.get('ConfigName');
    const pageid = that.activaRouter.snapshot.paramMap.get('id');
    let body = new WebParameterContext();
    body.ConfigName = "TBGiftQuotaXML";
    body.OpType = "query";
    body.ConfigType = "view";
    body.RowsPerPage = 15;
    body.PageNumber = 1;
    body.Client.PageName = PageName;
    body.Client.ApiType = "Element";
    body.Client.ClientType = 2;
    //  body.RequestBody={};
    //  body.RequestBody=JSON.stringify(_arrayList);
    body.RequestBody = JSON.stringify(_dy);

    that.http.post(app.DEFAULTURL, body).then(data => {
      /****判断是否第一页begin****/
      if (PageNumber == 1) {
        that.arrayData = [];
        that.apiObj['status'] = data.ResponseMessage.Success;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      } else {
        that.infiniteScroll.complete();
      }
      /****判断是否第一页end****/
      if (data.ResponseMessage.Success) {
        data.Status.Datas.forEach(item => {
          item.ChineseName = that.com.FormatName(item.ChineseName || "");
          item.Mobile = that.com.PhoneNum(item.Mobile || "");
          if(item.SignTimeEffect){
            item.SignTimeEffect = item.SignTimeEffect.replace(/-/g,"/").replace("T","");
          }
          if(item.CreateTime){
            item.CreateTime = item.CreateTime.replace(/-/g,"/").replace("T","");
          }
          that.arrayData.push(item);
        });
        /****上拉加载数据begin****/
        that.RecordCount = data.Status.RecordCount;
        if (that.RecordCount == data.Status.Datas.length || that.RecordCount == that.arrayData.length) {
          that.infiniteScroll.disabled = true;
        } else {
          that.infiniteScroll.disabled = false;
        }
        /****上拉加载数据end****/
      }else{
        that.apiObj['status'] = false;
        that.apiObj['msg'] = data.ResponseMessage.ErrorMessage;
        that.loading = true;
      }

    }).catch(error => {
      that.apiObj['status'] = false;
      that.apiObj['msg'] = error.ResponseMessage.ErrorMessage;
      that.loading = true;
      console.log(error);
    });
  }
  /**
* 
* @param e 跳转页面
*/
  EventLink(item) {
    console.log(item)
    const that = this;
    if (item) {
      that.com.setHistoryUrl(true);
      if(item.SignTime){
        item.SignTime=item.SignTime.replace(/-/g,"/").replace("T"," ");
      }
      // 参数拼接
      let queryObj = {
        ID: item.ID,
        FK_TBStore_ID: item.FK_TBStore_ID,//门店id
        SignerName: item.SignerName, // 签收人
        FK_TBStore_Name: item.FK_TBStore_Name, // 门店名称
        SignTimeEffect: item.SignTime,// 日期
        SignState: item.SignState, // 返回的签收状态
        Img: item.ImgUrl,
        MessageFeedback: item.MessageFeedback // 备注
      }
      that.com.Go("/tabs/contact/GiftReceiptForm/" + this.com.getNowDatetime,queryObj);
      // that.router.navigate(["/tabs/contact/GiftReceiptForm/" + this.com.getNowDatetime], {
      //   queryParams: {
      //     ID: item.ID,
      //     FK_TBStore_ID: item.FK_TBStore_ID,//门店id
      //     SignerName: item.SignerName, // 签收人
      //     FK_TBStore_Name: item.FK_TBStore_Name, // 门店名称
      //     SignTimeEffect: item.SignTime,// 日期
      //     SignState: item.SignState, // 返回的签收状态
      //     Img: item.ImgUrl,
      //     MessageFeedback: item.MessageFeedback // 备注
      //   }
      // });
    }

  }

}
